const outputs = {
  outputs: 'Sorties',
  table: {
    displayName: "Nom d'affichage",
    serialNumber: 'Numéro de série',
    searchPlaceHolder: "Nom d'affichage / numéro de série",
    enabled: 'Activé',
  },
  modal: {
    title: 'Propriétés des sorties',
    tabInformation: 'Informations générales',
    TabEvents: 'Événements',
  },
  form: {
    checkEnable: 'Activer',
    radioNormallyOpen: 'Normalement ouvert',
    radioNormallyClose: 'Normalement fermé',
  },
};

export default outputs;
